import type { Context, Provider } from 'react';
import { createContext } from 'react';

import type { ADNode } from '@atlaskit/editor-common/validator';

/**
 * Provides the full page ADF document to the render tree.
 * Used by nested renderers (e.g. Legacy Content Macro) so that macros like ToC
 * can use the full page document instead of only the nested content.
 */
export const PageDocumentContext: Context<ADNode | undefined> = createContext<ADNode | undefined>(
	undefined,
);

export const PageDocumentProvider: Provider<ADNode | undefined> = PageDocumentContext.Provider;
